function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M0.261423 0.285266C0.429029 0.117869 0.656226 0.0238433 0.89311 0.0238433C1.12999 0.0238433 1.35719 0.117869 1.5248 0.285266L5.36259 4.12306L9.20039 0.285266C9.30965 0.1676 9.44862 0.0815818 9.60267 0.0362742C9.75671 -0.00903338 9.92013 -0.0119527 10.0757 0.0278235C10.2313 0.0675998 10.3732 0.148599 10.4866 0.262287C10.6 0.375976 10.6806 0.518144 10.72 0.673813C10.7598 0.829204 10.7571 0.992455 10.712 1.1464C10.6669 1.30035 10.5811 1.4393 10.4638 1.54864L6.62596 5.38643L10.4638 9.22423C10.5814 9.33349 10.6674 9.47246 10.7128 9.62651C10.7581 9.78056 10.761 9.94397 10.7212 10.0995C10.6814 10.2551 10.6004 10.3971 10.4867 10.5105C10.373 10.6238 10.2309 10.7045 10.0752 10.7439C9.91982 10.7837 9.75657 10.7809 9.60262 10.7358C9.44868 10.6907 9.30973 10.605 9.20039 10.4876L5.36259 6.64981L1.5248 10.4876C1.35524 10.6454 1.13111 10.7314 0.89951 10.7274C0.667911 10.7234 0.446881 10.6297 0.282876 10.4661C0.119302 10.3021 0.0256744 10.0811 0.0216736 9.84951C0.0176729 9.61792 0.10361 9.39378 0.261423 9.22423L4.09922 5.38643L0.261423 1.54864C0.0940255 1.38103 0 1.15384 0 0.916953C0 0.68007 0.0940255 0.452872 0.261423 0.285266Z",
  fill: "#EB5757"
});
const SvgWrong = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWrong, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wrong.42926667.svg";
export { ForwardRef as ReactComponent };